import React from "react";

/**
 * Context for TempurLove grid root URL.
 * Used to provide the root URL to nested components (like CategoriesFooter)
 * for building category links consistently in both SSR and client rendering.
 */
export const TempurLoveRootUrlContext = React.createContext<string | null>(
    null,
);
